import React from 'react';
import { useStats } from 'react-instantsearch';

interface StatsProps {
  className?: string;
}

export const Stats: React.FC<StatsProps> = ({ className = '' }) => {
  const { nbHits, processingTimeMS, areHitsSorted } = useStats();

  const formatProcessingTime = (time: number) => {
    return time < 1000 ? `${time}ms` : `${(time / 1000).toFixed(1)}s`;
  };

  return (
    <div className={`text-sm text-muted-foreground ${className}`}>
      {nbHits > 0 ? (
        <>
          {nbHits.toLocaleString()} result{nbHits !== 1 ? 's' : ''} found
          {processingTimeMS !== undefined && (
            <> in {formatProcessingTime(processingTimeMS)}</>
          )}
          {areHitsSorted && <> (sorted)</>}
        </>
      ) : (
        'No results found'
      )}
    </div>
  );
};